<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="toc"><a id="page_vii">CONTENTS</a></h2><a id="page_vii">
</a><p class="toc"><a id="page_vii"></a><a href="#/xhtml/pref#pref"><em>Preface</em></a></p>
<p class="tocb"><a href="#/xhtml/intro#intro"><em>Introduction</em></a></p>
<p class="toc"><a href="#/xhtml/ch01#ch01"><strong>ONE</strong> The Case for Communications</a></p>
<p class="toc"><span href="#/xhtml/ch02#ch02" title="Link target outside of Sample"><strong>TWO</strong> Be Credible</span></p>
<p class="toc"><span href="#/xhtml/ch03#ch03" title="Link target outside of Sample"><strong>THREE</strong> Be Creative</span></p>
<p class="toc"><span href="#/xhtml/ch04#ch04" title="Link target outside of Sample"><strong>FOUR</strong> Be Responsive</span></p>
<p class="toc"><span href="#/xhtml/ch05#ch05" title="Link target outside of Sample"><strong>FIVE</strong> Be Relentless</span></p>
<p class="toc"><span href="#/xhtml/ch06#ch06" title="Link target outside of Sample"><strong>SIX</strong> Social Media on an Ordinary Budget</span></p>
<p class="toc"><span href="#/xhtml/ch07#ch07" title="Link target outside of Sample"><strong>SEVEN</strong> PR Tactics on An Ordinary Budget</span></p>
<p class="tocb"><span href="#/xhtml/ch08#ch08" title="Link target outside of Sample"><strong>EIGHT</strong> Crisis Communications</span></p>
<p class="tocb"><span href="#/xhtml/conclu#conclu" title="Link target outside of Sample"><em>Conclusion: Leading in the Midst of Fear Using the Four Principles</em></span></p>
<p class="toc"><span href="#/xhtml/ack#ack" title="Link target outside of Sample"><em>Acknowledgments</em></span></p>
<p class="toc"><span href="#/xhtml/glos#glos" title="Link target outside of Sample"><em>Glossary</em></span></p>
<p class="toc"><span href="#/xhtml/notes#notes" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc"><span href="#/xhtml/index#index" title="Link target outside of Sample"><em>Index</em></span></p>
<p class="toc"><span href="#/xhtml/about#about" title="Link target outside of Sample"><em>About the Author</em></span><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?0fe6a802